(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horus-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-horus-hero]');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const media = hero.querySelector('[data-horus-hero-media]');
    if (!media) return;
    let queued = false;
    const update = () => {
      const rect = hero.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const offset = Math.max(-18, Math.min(18, rect.top * -.025));
        media.style.transform = `scale(1.035) translate3d(0, ${offset}px, 0)`;
      }
      queued = false;
    };
    window.addEventListener('scroll', () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('horus-variant-preview')) {
    customElements.define(
      'horus-variant-preview',
      class HorusVariantPreview extends HTMLElement {
        connectedCallback() {
          this.productInfo = this.closest('product-info');
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
          this.productInfo?.addEventListener('change', this.handleVariantChange);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantUpdate);
          }
          this.activate(this.dataset.selectedColor || 'Horus');
        }

        disconnectedCallback() {
          this.productInfo?.removeEventListener('change', this.handleVariantChange);
          this.variantChangeUnsubscriber?.();
        }

        handleVariantChange(event) {
          if (['Horus', 'Anubis', 'Sechmet'].includes(event.target.value)) {
            this.activate(event.target.value);
          }
        }

        handleVariantUpdate({ data }) {
          if (data.sectionId !== this.productInfo?.sectionId) return;
          const selectedColor = data.variant?.options?.find((option) =>
            ['Horus', 'Anubis', 'Sechmet'].includes(option)
          );
          if (selectedColor) this.activate(selectedColor);
        }

        activate(value) {
          const selectedStage = this.querySelector(`[data-preview-color="${value}"]`);
          if (!selectedStage) return;
          this.dataset.selectedColor = value;
          this.querySelectorAll('[data-preview-color]').forEach((stage) => {
            stage.hidden = stage !== selectedStage;
          });
        }
      }
    );
  }

  if (!customElements.get('horus-collector-gallery')) {
    customElements.define(
      'horus-collector-gallery',
      class HorusCollectorGallery extends HTMLElement {
        connectedCallback() {
          this.productInfo = this.closest('product-info');
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
          this.handleColorClick = this.handleColorClick.bind(this);
          this.productInfo?.addEventListener('change', this.handleVariantChange);
          this.addEventListener('click', this.handleColorClick);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantUpdate);
          }
          this.activate(this.dataset.selectedVariant || 'Horus');
        }

        disconnectedCallback() {
          this.productInfo?.removeEventListener('change', this.handleVariantChange);
          this.removeEventListener('click', this.handleColorClick);
          this.variantChangeUnsubscriber?.();
        }

        handleVariantChange(event) {
          if (['Horus', 'Anubis', 'Sechmet'].includes(event.target.value)) {
            this.activate(event.target.value);
          }
        }

        handleVariantUpdate({ data }) {
          if (data.sectionId !== this.productInfo?.sectionId) return;
          const selectedColor = data.variant?.options?.find((option) =>
            ['Horus', 'Anubis', 'Sechmet'].includes(option)
          );
          if (selectedColor) this.activate(selectedColor);
        }

        handleColorClick(event) {
          const button = event.target.closest('[data-collector-select]');
          if (!button) return;
          const value = button.dataset.collectorSelect;
          const input = Array.from(this.productInfo?.querySelectorAll('input[type="radio"]') || []).find(
            (candidate) => candidate.value === value
          );
          if (input && !input.checked) {
            input.click();
          } else {
            this.activate(value);
          }
        }

        activate(value) {
          this.dataset.selectedVariant = value;
          this.querySelectorAll('[data-collector-stage]').forEach((stage) => {
            stage.hidden = stage.dataset.collectorStage !== value;
          });
          this.querySelectorAll('[data-collector-component-image]').forEach((image) => {
            image.hidden = image.dataset.collectorComponentImage !== value;
          });
          this.querySelectorAll('[data-collector-select]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.collectorSelect === value));
          });
          const selectedButton = this.querySelector(`[data-collector-select="${value}"]`);
          const selectedLabel = this.querySelector('[data-selected-color]');
          if (selectedButton && selectedLabel) selectedLabel.textContent = selectedButton.dataset.colorLabel;
        }
      }
    );
  }

  if (!customElements.get('horus-product-legend')) {
    customElements.define(
      'horus-product-legend',
      class HorusProductLegend extends HTMLElement {
        connectedCallback() {
          this.productInfo = this.closest('product-info');
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
          this.productInfo?.addEventListener('change', this.handleVariantChange);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantUpdate);
          }
          this.activate(this.dataset.selectedColor || 'Horus');
        }

        disconnectedCallback() {
          this.productInfo?.removeEventListener('change', this.handleVariantChange);
          this.variantChangeUnsubscriber?.();
        }

        handleVariantChange(event) {
          if (['Horus', 'Anubis', 'Sechmet'].includes(event.target.value)) {
            this.activate(event.target.value);
          }
        }

        handleVariantUpdate({ data }) {
          if (data.sectionId !== this.productInfo?.sectionId) return;
          const selectedColor = data.variant?.options?.find((option) =>
            ['Horus', 'Anubis', 'Sechmet'].includes(option)
          );
          if (selectedColor) this.activate(selectedColor);
        }

        activate(value) {
          this.dataset.selectedColor = value;
          this.querySelectorAll('[data-legend-color]').forEach((sign) => {
            const isActive = sign.dataset.legendColor === value;
            sign.classList.toggle('is-active', isActive);
            if (isActive) {
              sign.setAttribute('aria-current', 'true');
            } else {
              sign.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
